<template>
  <main class="container-fluid">
    <div class="launding row">
      <div class="launding__inner col-12 d-flex">
        <div class="launding__logo mx-auto">
          <img class="launding__logo-img img-fluid" :alt="'Logo ' + $appName" :src="require(`@/assets/images/logo-title-${$appName}.png`)">
        </div>
        <div class="launding__intro">
          <h1 v-if="$appName === 'bestove'" class="launding__title">Bienvenue sur le SAV de Bestove</h1>
          <h1 v-else class="launding__title">Bienvenue sur le site servicepoele.fr</h1>
          <h2 class="launding__title">Votre spécialiste en poêles et inserts à granulés de bois</h2>
          <div class="launding__baseline">Installation | Entretien | Pièces détachées | Dépannage</div>
        </div>

        <div class="launding__content container-fluid container-fluid--max">
          <div class="row">
            <section class="col-md-6">
              <div class="launding__card launding__card--light card">
                <div class="launding__card-body card-body px-md-5 py-4">
                  <h3 class="launding__subtitle text-uppercase mb-0">Espace particulier</h3>
                  <hr class="separator-deco mx-auto my-4">
                  <p class="mb-4">Enregistrez votre produit et gérez facilement la mise en service, l’entretien et le SAV, directement depuis votre espace.</p>
                  <router-link :to="{ name: 'clientDashboard' }" tag="button" class="btn mt-auto px-md-5 align-self-center" :class="'btn-outline-' + $mainColor">Accéder</router-link>
                </div>
              </div>
            </section>
            <section class="col-md-6 mt-4 mt-md-0">
              <div class="launding__card launding__card--dark card">
                <div class="launding__card-body card-body px-md-5 py-4">
                  <h3 class="launding__subtitle text-uppercase mb-0">Espace professionnel</h3>
                  <hr class="separator-deco mx-auto my-4">
                  <p class="mb-4">Accédez à une suite de services pour faciliter votre travail au quotidien.</p>
                  <router-link :to="{ name: 'userDashboard' }" tag="button" class="btn mt-auto px-md-5 align-self-center" :class="'btn-' + $mainColor">Accéder</router-link>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>

      <footer class="launding__footer">
        <span v-if="$appName === 'bestove'" class="launding__mini-logo-icon bestove-icon__logo" title="Logo Bestove"></span>
        <span v-else class="launding__mini-logo">
          <img class="launding__mini-logo-img img-fluid" :alt="'Logo ' + $appName" :src="require(`@/assets/images/logo-title-${$appName}.png`)">
        </span>
        <p class="launding__credits my-3 ml-2">
          © Bestove 2019 - Tous droits réservés - Service client :
          <strong>
            01 41 95 63 10
          </strong>
        </p>
      </footer>
    </div>
  </main>
</template>

<script>
export default {
  name: 'Home'
}
</script>
